"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  background: white;\n"])));

var StyledTabButton = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 1 ", "%;\n  width: ", "%;\n  height: 3rem;\n"])), function (p) {
  return 100 / p.numberOfTabs;
}, function (p) {
  return 100 / p.numberOfTabs;
});

var StyledUnderline = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: ", "%;\n  height: 4px;\n  background: ", ";\n\n  transform: translateX(", "%);\n  transition: transform 0.35s;\n"])), function (p) {
  return 100 / p.numberOfTabs;
}, function (p) {
  return p.theme.colorPrimary;
}, function (p) {
  return p.activeTab === 0 ? 0 : p.activeTab * 100;
});

var Wrapper = function Wrapper(_ref) {
  var tabs = _ref.tabs,
      activeTab = _ref.activeTab,
      onTabClicked = _ref.onTabClicked;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledUnderline, {
      activeTab: activeTab,
      numberOfTabs: tabs.length
    }), tabs.map(function (tab, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTabButton, {
        numberOfTabs: tabs.length,
        onClick: function onClick() {
          return onTabClicked(index);
        },
        isActive: index === activeTab,
        children: tab
      });
    })]
  });
};

var _default = Wrapper;
exports.default = _default;